<template>
  <div class="combatant-list">
    <div v-for="combatant in combatants" class="f m-bx4">
      <div class="f-v f-sa m-rx3">
        <button class="button bg-dark-gray w-x6 h-x6" @click="destroy(combatant)">
          <span class="material-symbols-outlined white t-16"> delete </span>
        </button>
        <button v-if="!combatant.isPC" class="button bg-dark-gray w-x6 h-x6 m-tx2" @click="duplicate(combatant)">
          <span class="material-symbols-outlined white t-16"> content_copy </span>
        </button>
      </div>
      <CombatEncounterCombatant :uuid="combatant.uuid" />
    </div>
  </div>
</template>

<script setup>
  import { computed } from 'vue';
  import { useCombatEncounterStore } from '../../stores/combat_encounter_store';

  const store = useCombatEncounterStore();

  const combatants = computed(() => store.combatants);

  const destroy = (combatant) => {
    store.destroyCombatant(combatant);
  };
  const duplicate = (combatant) => {
    store.addMonsterToCombatants(combatant);
  };
</script>